<template>
  <div class="banner">
    <div class="video">
      <video
        ref="videoAutoplay"
        src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/mp4/1-1.mp4"
        width="100%"
        height="100%"
        autoplay
        muted
        loop
      ></video>
    </div>
    <div class="homeTitle">
      <div class="homeLogo">
        <img
          v-lazy="hrefurl + '/public/home/title%26bg/logo.png'"
          alt="振威石油展"
        />
      </div>
      <h1>
        <img
          v-lazy="hrefurl + '/public/home/banner/red_dot.png'"
          alt="网上展览"
        />
      </h1>
      <p>双线会展&nbsp;/&nbsp;创赢未来</p>
      <div>
        <img
          class="suspend"
          v-lazy="hrefurl + '/public/icon/stop.png'"
          alt=""
        />
      </div>
    </div>
    <div class="btn" v-if="!isLogin">
      <!-- <button @click="jumpLogin">展商登录</button> -->
      <button @click="login">观众登录</button>
    </div>
    <div
      class="down"
      @click="
        () => {
          this.$emit('rolling');
        }
      "
    >
      <img v-lazy="hrefurl + '/public/icon/down.png'" alt="" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  methods: {
    login() {
      // 登录
      this.isPath1(this);
      this.$store.dispatch("dialog", true);
    },

    jumpLogin() {
      // 展商登录
      this.webHerf("https://e.cippe.com.cn/cn/member/login");
    },
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
    }),
  },
};
</script>

<style scoped>
.suspend {
  opacity: 0;
}
.banner {
  position: relative;
  background-color: #000;
}
.banner video {
  vertical-align: bottom;
}
.homeTitle {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
}
img {
  object-fit: initial;
  width: auto;
  height: auto;
  margin-bottom: 20px;
}
.homeTitle p {
  color: white;
  font-size: 24px;
  margin-bottom: 20px;
}
.btn {
  position: absolute;
  left: calc(50% - 250px);
  width: 500px;
  bottom: 70px; /*no*/
  text-align: center;
}
.btn > button {
  width: 240px; /*no*/
  height: 40px; /*no*/
  border-radius: 20px; /*no*/
  background-image: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/bannerBtn.png");
  background-size: 100% 100%;
  border: none;
  color: white;
  font-size: 16px; /*no*/
  line-height: 40px; /*no*/
  outline: none;
  transition: all 0.5s;
  cursor: pointer;
  border: 1px solid #fff;
  font-weight: 600;
  font-family: "Microsoft YaHei";
  letter-spacing: 0.14em;
}
.btn > button:hover {
  background-image: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/bannerBtn_1.png");
}

.down {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  height: 50px;
  animation: bounce-down 1.6s linear infinite;
  cursor: pointer;
}
.down img {
  height: 100%;
}

@keyframes bounce-down {
  25% {
    transform: translate(-50%, -4px);
  }
  50%,
  100% {
    transform: translate(-50%, 0);
  }
  75% {
    transform: translate(-50%, 4px);
  }
}
</style>
